import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, FormControl } from '@angular/forms';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { fuseAnimations } from '@fuse/animations';
import { default as _rollupMoment, Moment } from 'moment';
import * as _moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MatDatepicker, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-page-visit',
  templateUrl: './page-visit.component.html',
  styleUrls: ['./page-visit.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class PageVisitComponent implements OnInit {

  reportingToDD: any[];
  data: any;
  startDate = new Date();
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });
  selectedTeam = 'overall';
  totalRecords: any;
  timesheetRecord: any;
  screenshotRecord: any;
  selectedDate = new Date();
  selectedTeamMembers: any;
  teamMembersProfileId = [];
  currentDate = new Date();
  formDate = new FormControl(moment());
  teamTimesheetCount = 0;
  teamScreenshotsCount = 0;
  public chartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    }
  }
  teamVisitResult = [];
  timesheetTable = [];
  screenshotsTable = [];
  timesheetRanking = [];
  screenshotRanking = [];
  selectedTeamLeaderName = '';
  selectedTeamLeaderRole = '';
  selectedTeamLeaderNameProfileImage = '';
  notificationList = [];
  recieverName: any;
  activities = [];
   

  constructor(private spinner: NgxSpinnerService,
    private getReportingToService: GetReportingToService,
    private parseService: ParseService,
    private hardCodedValues: HardCodedValues,
    private storageConfiguration: StorageConfiguration
  ) {
     

  }

  async ngOnInit() {
    await this.getReportingTo();
    this.getUserTimesheet();
    this.getScreenshots();

    this.getRankingData();
  }

  async getReportingTo() {
    this.reportingToDD = [];
    this.spinner.show();
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToDD = res;
      this.spinner.hide();
    });
  }

  async getRankingData(selectedDate?) {
    this.timesheetTable = [];
    this.screenshotsTable = [];
    let pageVisitClass = this.parseService.instance.Object.extend('PageVisit');
    let pageVisitQuery = new this.parseService.instance.Query(pageVisitClass);
    let dateDifferents = this.startenddates(selectedDate ? selectedDate : new Date());
    pageVisitQuery.greaterThan('createdAt', dateDifferents[0]);
    pageVisitQuery.lessThan('createdAt', dateDifferents[1]);
    pageVisitQuery.include('ownerId');
    pageVisitQuery.include('receiverId');
    pageVisitQuery.limit(1000000000);
    let results = await pageVisitQuery.find();
    results = JSON.parse(JSON.stringify(results));
    let groupedPageType = this.groupDataByProperty(results, 'pageType')
    let rankedData = [];
    for (let props in groupedPageType) {
      let groupedUserName = this.groupNestedObjectBy(groupedPageType[props], 'ownerId.username');
      for (let name in groupedUserName) {
        let rankedDataItem: any = {};
        rankedDataItem.pageType = props;
        rankedDataItem.name = name;
        rankedDataItem.id = groupedUserName[name][0].ownerId.objectId;
        rankedDataItem.profileImage = groupedUserName[name][0].ownerId.profileImageInfo.url ? groupedUserName[name][0].ownerId.profileImageInfo.url : "assets/images/avatars/profile.jpg";
        rankedDataItem.count = groupedUserName[name].length;
        rankedDataItem.role = groupedUserName[name][0].ownerId.role.name;
        let indexRankedData = rankedData.findIndex(x => x.id == groupedUserName[name][0].ownerId.objectId && x.pageType == props)
        if (indexRankedData == -1) {
          rankedData.push(rankedDataItem);
        }
      }
    }
    this.timesheetRanking = rankedData.filter(x => x.pageType == 'Timesheet').sort((a, b) => parseFloat(b.count) - parseFloat(a.count)).slice(0, 3);
    this.screenshotRanking = rankedData.filter(x => x.pageType == 'Screenshots').sort((a, b) => parseFloat(b.count) - parseFloat(a.count)).slice(0, 3);

    // Timesheet and Screenshots table data
    for (const element of this.reportingToDD) {
      let timesheet = results.filter(x => x.ownerId.objectId == element.value && x.pageType == 'Timesheet');
      let screenshot = results.filter(x => x.ownerId.objectId == element.value && x.pageType == 'Screenshots');

      var queryProfile = new this.parseService.instance.Object('Profile');
      queryProfile.id = element.value;
      let profile = '';
      var myObj = queryProfile.get('profileImageInfo');
      if (this.isEmpty(myObj)) {
        // Object is empty
        profile = this.hardCodedValues.defaultProfileImg;
      } else {
        // Object is NOT empty
        profile = queryProfile.get('profileImageInfo').url
      }
      this.timesheetTable.push({
        name: element.label,
        image: profile,
        designation: queryProfile.get('role').get('name'),
        timesheetViewerCount: timesheet.length
      });
      this.screenshotsTable.push({
        name: element.label,
        image: profile,
        designation: queryProfile.get('role').get('name'),
        screenshotsViewerCount: screenshot.length
      });
    }
    this.timesheetTable.sort((a, b) => {
      return b.timesheetViewerCount - a.timesheetViewerCount;
    });
    this.screenshotsTable.sort((a, b) => {
      return b.screenshotsViewerCount - a.screenshotsViewerCount;
    });
    this.timesheetTable.splice(10);
    this.screenshotsTable.splice(10);

  }

  groupDataByProperty(data, property) {
    let processed = data.reduce((r, a) => {
      let propertyValue = a[property]
      r[propertyValue] = r[propertyValue] || [];
      r[propertyValue].push(a);
      return r;
    }, Object.create(null));
    return processed;
  }

  groupNestedObjectBy(array, property) {
    var hash = {},
      props = property.split('.');
    for (var i = 0; i < array.length; i++) {
      var key = props.reduce(function (acc, prop) {
        return acc && acc[prop];
      }, array[i]);
      if (!hash[key]) hash[key] = [];
      hash[key].push(array[i]);
    }
    return hash;
  }

  async chooseTeam() {

    var queryProfile = new this.parseService.instance.Object('Profile');
    queryProfile.id = this.selectedTeam;

    this.selectedTeamLeaderName = queryProfile.get('firstName') + ' ' + queryProfile.get('lastName');
    this.selectedTeamLeaderRole = queryProfile.get('role').get('name');
    let profile = '';
    var myObj = queryProfile.get('profileImageInfo');
    if (this.isEmpty(myObj)) {
      profile = this.hardCodedValues.defaultProfileImg;
    } else {
      profile = queryProfile.get('profileImageInfo').url
    }
    this.selectedTeamLeaderNameProfileImage = profile;

    this.selectedTeamMembers = [];
    this.teamMembersProfileId = [];
    let userTimesheetClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(userTimesheetClass);
    query.withCount();
    query.include('reportingTo');
    query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.selectedTeam });
    query.equalTo('isActive', true);
    query.equalTo('isLongLeave', false);
    query.limit(10000);
    let results = await query.find();
    this.selectedTeamMembers = JSON.parse(JSON.stringify(results.results));
    for (const element of this.selectedTeamMembers) {
      this.teamMembersProfileId.push(element.objectId);
    }
    this.getTeamPageVisit();
  }

  async getUserTimesheet() {
    let userTimesheetClass = this.parseService.instance.Object.extend('PageVisit');
    let query = new this.parseService.instance.Query(userTimesheetClass);
    query.withCount();
    query.limit(1);
    query.equalTo('pageType', 'Timesheet');
    let results = await query.find();
    this.timesheetRecord = results.count;
  }

  async getScreenshots() {
    let screenshotsClass = this.parseService.instance.Object.extend('PageVisit');
    let query = new this.parseService.instance.Query(screenshotsClass);
    query.withCount();
    query.limit(1);
    query.equalTo('pageType', 'Screenshots');
    let results = await query.find();
    this.screenshotRecord = results.count;
  }

  async getTeamPageVisit(selectedDate?) {
    let screenshotsClass = this.parseService.instance.Object.extend('PageVisit');
    let query = new this.parseService.instance.Query(screenshotsClass);
    const startend = this.startenddates(selectedDate ? selectedDate : this.selectedDate);
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    // query.containedIn('receiverId', this.teamMembersProfileId);
    query.include('ownerId');
    query.equalTo('ownerId', { __type: 'Pointer', className: 'Profile', objectId: this.selectedTeam });
    query.withCount();
    query.limit(1000000000);
    let results = await query.find();
    this.teamVisitResult = JSON.parse(JSON.stringify(results.results));
    this.activities = (this.teamVisitResult).slice(0, 10);
    let timesheet = this.teamVisitResult.filter(x => x.pageType == 'Timesheet');
    let screenshots = this.teamVisitResult.filter(x => x.pageType == 'Screenshots');
    this.teamTimesheetCount = timesheet.length;
    this.teamScreenshotsCount = screenshots.length;
    // let teamNames = [];
    // let teamTimesheets = [];
    // let teamScreenshots = [];
    // if (this.selectedTeamMembers.length > 0) {
    //   this.selectedTeamMembers.forEach(element => {
    //     let timesheet = this.teamVisitResult.filter(x => x.receiverId.objectId == element.objectId && x.pageType == 'Timesheet');
    //     let screenshot = this.teamVisitResult.filter(x => x.receiverId.objectId == element.objectId && x.pageType == 'Screenshots');
    //     teamNames.push(element.firstName + ' ' + element.lastName);
    //     teamTimesheets.push(timesheet.length);
    //     teamScreenshots.push(screenshot.length);
    //   });
    // }
    // this.data = {
    //   labels: teamNames,
    //   datasets: [
    //     {
    //       label: 'Timesheet',
    //       backgroundColor: '#537abf',
    //       borderColor: '#537abf',
    //       data: teamTimesheets
    //     },
    //     {
    //       label: 'Screenshot',
    //       backgroundColor: '#966587',
    //       borderColor: '#966587',
    //       data: teamScreenshots
    //     }
    //   ]
    // }
  }

  nextPage(event) {
    let activity = this.teamVisitResult;
    let start = event.pageIndex * event.pageSize;
    this.activities = activity.slice(start, start + event.pageSize);
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  chosenYearHandler(normalizedYear: Moment): void {
    const ctrlValue = this.formDate.value;
    ctrlValue.year(normalizedYear.year());
    this.formDate.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>): void {
    const ctrlValue = this.formDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.formDate.setValue(ctrlValue);
    let date = new Date(this.formDate.value);
    let filterDate = date.getMonth() == new Date().getMonth() ? new Date() : new Date(date.getFullYear(), date.getMonth() + 1, 0);
    if (this.selectedTeam == 'overall') {
      this.getRankingData(filterDate);
    }
    else {
      this.getTeamPageVisit(filterDate);
    }
    datepicker.close();
  }

  dayafter(d) {
    const day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth() + 1, 1);
  }

  daybefore(d) {
    const day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), 0);
  }

  startenddates(day) {
    const startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    const enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

}
